import { flowRight, get } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

import { getPageloadTraceId } from '../../../../config/pageload/selector';
import SearchResults from './SearchResults';
import {
    trackScrolledToSearchResult,
} from '../../../actions';

import {
    getInsuranceCarrierId,
    getInsurancePlanId,
    getSearchParameters,
} from '../../../state';

import {
    getAvailabilityTimeFilter,
    getAvailabilityTimeFilterForFacetedSearch,
} from '../../../utils/get-availability-time-filter';

import { mockable } from '../../../../config/mockable';

const mapStateToProps = (state, ownProps) => {
    const {
        filters,
        showTimesAfter5,
        showTimesBefore10,
    } = getSearchParameters(state);

    const { shouldRenderFacetedSearchBar, facets } = ownProps;

    const availabilityTimeFilter = shouldRenderFacetedSearchBar
        ? getAvailabilityTimeFilterForFacetedSearch(filters, facets)
        : getAvailabilityTimeFilter(showTimesBefore10, showTimesAfter5);

    return {
        availabilityTimeFilter,
        insuranceCarrierId: getInsuranceCarrierId(state),
        insurancePlanId: getInsurancePlanId(state),
        pageId: get(getPageloadTraceId(state), 'pageTraceId'),
    };
};

const mapDispatchToProps = {
    trackScrolledToSearchResult,
};

const SearchResultsConnected = flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({ section: 'SearchResults' }),
)(SearchResults);

const searchResultsResolver = () => SearchResultsConnected;

const SearchResultsMockable = mockable(searchResultsResolver);

export {
    searchResultsResolver,
    SearchResultsMockable as default,
};
